import { HttpErrorResponse } from '@angular/common/http';
import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import * as i1 from '@yourcause/common/utils';

class LoggingModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LoggingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: LoggingModule }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LoggingModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LoggingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [],
                    exports: [],
                    providers: [],
                }]
        }] });

class LogService {
    constructor(appInsights, uuid) {
        this.appInsights = appInsights;
        this.uuid = uuid;
    }
    /**
     * Log a message to our logging service
     *
     * @param message Message to be logged
     * @param extras Additional properties to be attached to the log. Useful for 'tagging' logs for easy lookup
     */
    log(message, extras) {
        console.log(message, ...(extras ? [extras] : []));
        this.appInsights.trackEvent('log', {
            message,
            ...extras
        });
    }
    /**
     * Track an exception in our logging service
     *
     * @param error Error to be logged
     * @param message optional message to help track log down in log service
     */
    error(error, extras = {}) {
        let errorMessage = !!error && 'message' in error ? error.message : '';
        if (error instanceof HttpErrorResponse) {
            errorMessage = error.error?.message ?? errorMessage;
        }
        if (!(error instanceof Error)) {
            error = new Error(errorMessage);
        }
        const errorId = this.uuid.short();
        console.error(error);
        console.error('error id', errorId);
        this.appInsights.trackException(error, null, {
            ...extras,
            errorId,
            errorMessage,
            wasAngular: 'True',
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LogService, deps: [{ token: i1.AppInsightsService }, { token: i1.GuidService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LogService, providedIn: LoggingModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LogService, decorators: [{
            type: Injectable,
            args: [{ providedIn: LoggingModule }]
        }], ctorParameters: () => [{ type: i1.AppInsightsService }, { type: i1.GuidService }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LogService, LoggingModule };
